import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { CarrierModel } from '../../../../../common/models/carrier.model';

export function carrierSapValidator(control: AbstractControl): ValidationErrors {
  const parentForm = control.parent as UntypedFormGroup;

  if (parentForm) {
    const erpControl = parentForm.get('erp') as UntypedFormControl;
    const controlValue: CarrierModel | CarrierModel[] = control.value;

    if (erpControl?.value && controlValue) {
      if (Array.isArray(controlValue)) {
        return controlValue.some((carrier: CarrierModel) => !carrier.number) ? { sapCarrierError: true } : null;
      } else {
        return !controlValue?.number ? { sapCarrierError: true } : null;
      }
    } else {
      return null;
    }
  }

  return null;
}
